const CloseBtn = (props) => (
    <div
        data-testid="close"
        onClick={props.onClick}
        className={props.className || props.class}
        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        title={props.title}
    >
        <svg
            width={props.size || '16'}
            height={props.size || '16'}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill={props.colour === 'blue' ? '#123688' : props.colour ? props.colour : '#0b1a3f'}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.1186 0.701097C13.7281 0.310572 13.0949 0.310572 12.7044 0.701096L7.90774 5.49773L3.11115 0.701155C2.72063 0.31063 2.08747 0.31063 1.69694 0.701154L0.701231 1.69687C0.310707 2.08739 0.310706 2.72055 0.701231 3.11108L5.49781 7.90766L0.701097 12.7044C0.310572 13.0949 0.310572 13.7281 0.701096 14.1186L1.69681 15.1143C2.08733 15.5048 2.7205 15.5048 3.11102 15.1143L7.90774 10.3176L12.7045 15.1144C13.095 15.5049 13.7282 15.5049 14.1187 15.1144L15.1144 14.1186C15.505 13.7281 15.505 13.095 15.1144 12.7044L10.3177 7.90766L15.1143 3.11102C15.5048 2.7205 15.5048 2.08733 15.1143 1.69681L14.1186 0.701097Z"
            />
        </svg>
    </div>
);

export default CloseBtn;
